import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { environment } from '../../../../environments/environment';
import { IconComponent } from '../../../shared/icon/icon';
import { MarkdownPipe } from '../../../shared/pipes/markdown.pipe';

@Component({
  selector: 'app-terms',
  imports: [RouterLink, MatButtonModule, MatProgressSpinnerModule, IconComponent, MarkdownPipe],
  templateUrl: './terms.html',
  styleUrl: './terms.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TermsComponent implements OnInit {
  private readonly http = inject(HttpClient);

  protected readonly content = signal<string | null>(null);
  protected readonly isLoading = signal(true);
  protected readonly hasError = signal(false);

  ngOnInit(): void {
    this.fetchContent();
  }

  protected reload(): void {
    this.hasError.set(false);
    this.isLoading.set(true);
    this.fetchContent();
  }

  private fetchContent(): void {
    this.http.get<{ content: string }>(`${environment.apiUrl}/api/legal/terms/`).subscribe({
      next: (res) => {
        this.content.set(res.content);
        this.isLoading.set(false);
      },
      error: () => {
        this.hasError.set(true);
        this.isLoading.set(false);
      },
    });
  }
}
